import { ModelConfigParams, genericApplicationChecklistMFG, genericApplicationChecklistQC } from "./model-config-params";

export const cardiac: ModelConfigParams = {
  bodyParts: [
    'azygosVein',
    'artery',
    'vein',
    'coronaryArtery',
    'pulmonaryArtery',
    'pulmonaryVein',
    'heartAtriumLeft',
    'heartAtriumRight',
    'heartVentricleLeft',
    'heartVentricleRight',
    'heartMyocardium',
  ],
  checklist: genericApplicationChecklistMFG,
  checklistQC: genericApplicationChecklistQC,
  defaultIntensityRange: [-40, 1560],
  internal: true,
}
